
import { SUPABASE_URL } from '@/utils/supabaseConfig';
import { getApiHeaders } from '@/pages/admin/rentals/services/apiUtils';
import { PaymentHistoryItem, PaymentMethod } from '../types/collectionTypes';

// Получение истории платежей курьера
export const fetchCourierPaymentHistory = async (courierId: string): Promise<PaymentHistoryItem[]> => {
  try {
    console.log('Загружаем историю платежей для курьера:', courierId);
    
    const response = await fetch(
      `${SUPABASE_URL}/rest/v1/payments?select=id,amount,payment_date,status&courier_id=eq.${courierId}&order=payment_date.desc&limit=5`,
      {
        method: 'GET',
        headers: getApiHeaders(),
      }
    );
    
    if (!response.ok) {
      throw new Error(`Не удалось загрузить историю платежей: ${response.status}`);
    }
    
    const data = await response.json();
    console.log(`Загружено ${data.length} платежей для курьера ${courierId}`);
    
    return data;
  } catch (error) {
    console.error('Ошибка при загрузке истории платежей:', error);
    return [];
  }
};

// Получение платежных методов курьера
export const fetchCourierPaymentMethods = async (courierId: string): Promise<PaymentMethod[]> => {
  try {
    console.log('Загружаем платежные методы для курьера:', courierId);
    
    // Получение основных платежных методов курьера
    const response = await fetch(
      `${SUPABASE_URL}/rest/v1/couriers?select=payment_method_id,card_last4,card_type,card_expiry_month,card_expiry_year,payment_updated_at&id=eq.${courierId}`,
      {
        method: 'GET',
        headers: getApiHeaders(),
      }
    );
    
    if (!response.ok) {
      throw new Error(`Не удалось загрузить платежные методы: ${response.status}`);
    }
    
    const data = await response.json();
    const paymentMethods: PaymentMethod[] = [];
    
    // Обработка основного платежного метода
    if (data.length > 0 && data[0].payment_method_id) {
      const courier = data[0];
      paymentMethods.push({
        id: courier.payment_method_id,
        card_last4: courier.card_last4 || '****',
        card_type: courier.card_type || null,
        card_expiry_month: courier.card_expiry_month || null,
        card_expiry_year: courier.card_expiry_year || null,
        updated_at: courier.payment_updated_at || null,
        source: 'courier'
      });
    }
    
    // Получение платежных методов из подписок курьера (всех, а не только активных)
    try {
      // **ИСПРАВЛЕНИЕ**: используем более простой подход для запроса подписок по courier_id
      // Сначала получаем ID аренд для этого курьера
      const rentalsResponse = await fetch(
        `${SUPABASE_URL}/rest/v1/rentals?select=id&courier_id=eq.${courierId}`,
        {
          method: 'GET',
          headers: getApiHeaders(),
        }
      );
      
      if (!rentalsResponse.ok) {
        throw new Error(`Не удалось загрузить аренды: ${rentalsResponse.status}`);
      }
      
      const rentalsData = await rentalsResponse.json();
      console.log(`Найдено ${rentalsData.length} аренд для курьера ${courierId}`);
      
      if (rentalsData.length === 0) {
        return paymentMethods;
      }
      
      // Формируем список ID аренд для запроса
      const rentalIds = rentalsData.map((rental: any) => rental.id);
      
      // Теперь получаем подписки для этих аренд
      for (const rentalId of rentalIds) {
        const subscriptionsResponse = await fetch(
          `${SUPABASE_URL}/rest/v1/subscriptions?select=id,payment_method_id,card_last4,card_type,card_expiry_month,card_expiry_year,updated_at&payment_method_id=not.is.null&rental_id=eq.${rentalId}`,
          {
            method: 'GET',
            headers: getApiHeaders(),
          }
        );
        
        if (subscriptionsResponse.ok) {
          const subscriptionData = await subscriptionsResponse.json();
          console.log(`Найдено ${subscriptionData.length} подписок с платежными данными для аренды ${rentalId}`);
          
          // Добавление платежных методов из подписок
          for (const subscription of subscriptionData) {
            if (subscription.payment_method_id) {
              // Проверяем, не добавлен ли уже этот метод
              const exists = paymentMethods.some(m => m.id === subscription.payment_method_id);
              
              if (!exists) {
                paymentMethods.push({
                  id: subscription.payment_method_id,
                  card_last4: subscription.card_last4 || '****',
                  card_type: subscription.card_type || null,
                  card_expiry_month: subscription.card_expiry_month || null,
                  card_expiry_year: subscription.card_expiry_year || null,
                  updated_at: subscription.updated_at || null,
                  source: 'subscription',
                  subscription_id: subscription.id
                });
              }
            }
          }
        } else {
          // Выводим более детальную информацию об ошибке
          const errorText = await subscriptionsResponse.text();
          console.error(`Ошибка при загрузке подписок для аренды ${rentalId} (${subscriptionsResponse.status}):`, errorText);
        }
      }
    } catch (subscriptionError) {
      console.error('Ошибка при загрузке платежных методов из подписок:', subscriptionError);
      // Продолжаем выполнение даже при ошибке получения подписок
    }
    
    console.log(`Найдено ${paymentMethods.length} платежных методов для курьера ${courierId}`);
    return paymentMethods;
  } catch (error) {
    console.error('Ошибка при загрузке платежных методов:', error);
    return [];
  }
};
